import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Footer extends Vue {
  @Prop()
  private blur = false
}
